import getRuleBuilderConfig from 'omega-rtc/components/rule-builder/RuleBuilderConfig';

const ruleBuilderConfig = getRuleBuilderConfig({ countryIDKey: 'tridentCampaigns.active.countryID', useSegpWidget: true });
ruleBuilderConfig.hiddenRuleTypes.push(
  'var.ride.pickupCityID',
  'var.ride.serviceID',
  'var.payment.currency'
);
export default ruleBuilderConfig;
